import { render } from "./TaskGroupsList.vue?vue&type=template&id=17c89df2&scoped=true"
import script from "./TaskGroupsList.vue?vue&type=script&lang=js"
export * from "./TaskGroupsList.vue?vue&type=script&lang=js"

import "./TaskGroupsList.vue?vue&type=style&index=0&id=17c89df2&scoped=true&lang=css"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17c89df2"]])

export default __exports__